<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">拉新统计</span>
            </div>
            <div class="welcome-list">
                <div>
                    <p class="welcome-title">今日拉新</p>
                    <p class="welcome-blue">{{indexData.today_register_user}}</p>
                </div>
                <div>
                    <p class="welcome-title">本月拉新</p>
                    <p class="welcome-blue">{{indexData.month_register_user}}</p>
                </div>
                <div>
                    <p class="welcome-title">累计拉新</p>
                    <p class="welcome-blue">{{indexData.total_register_user}}</p>
                </div>
            </div>
        </el-card>
        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">充值统计</span>
            </div>
            <div class="welcome-list">
                <div>
                    <p class="welcome-title">今日充值</p>
                    <p class="welcome-blue">{{indexData.today_charge_money}}</p>
                </div>
                <div>
                    <p class="welcome-title">本月充值</p>
                    <p class="welcome-blue">{{indexData.month_charge_money}}</p>
                </div>
                <div>
                    <p class="welcome-title">累计充值</p>
                    <p class="welcome-blue">{{indexData.month_charge_money}}</p>
                </div>
            </div>
        </el-card>
        <el-card>
            <div slot="header" class="clearfix">
                <span class="table-title">每日汇总统计</span>
            </div>
            <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small">
                <el-form-item label="">
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择日期" v-model="searchForm.start_time"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择日期" v-model="searchForm.end_time"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="date"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="charge_total"
                        label="充值金额">
                </el-table-column>
                <el-table-column
                        prop="pay_person"
                        label="付费人数">
                </el-table-column>
                <el-table-column
                        prop="pay_nums"
                        label="付费笔数">
                </el-table-column>
                <el-table-column
                        prop="join_person"
                        label="新增用户">
                </el-table-column>
                <el-table-column
                        prop="join_person_pay_rate"
                        label="新用户付费率">
                </el-table-column>
                <el-table-column
                        prop="join_person_charge"
                        label="新用户充值金额(元)">
                </el-table-column>
                <el-table-column
                        prop="allusers"
                        label="累计用户数">
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="changeSize"
                    @current-change="changeCurrent"
                    :current-page="params.pagenum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="params.pagesize"
                    :layout="this.$store.state.paginationLayout"
                    :total="params.totals">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "Welcome",
        data() {
            return {
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0
                },
                tableData: [],
                indexData: [],
                searchForm: {
                    start_time: '',
                    end_time: '',
                },
            }
        },
        mounted() {
            this.PostIndex()
        },
        methods: {
            PostIndex() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    start_time: this.searchForm.start_time,
                    end_time: this.searchForm.end_time
                };
                this.$axios.post('mch/main/base_info', data).then(res => {
                    this.tableData = res.data.date_datas;
                    this.indexData = res.data;
                    this.params.totals = res.data.date_datas_count;
                })
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.PostIndex()
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.PostIndex()
            },
            search() {
                this.params.pagenum = 1;
                this.PostIndex()
            }

        }
    }
</script>

<style scoped lang="less">
    @media screen and (max-width: 750px) {
        .welcome-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;

            > div {
                text-align: center;
                width: 30% !important;
                margin-bottom: 20px;
            }
        }

        .eacharts-box {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .el-card {
                width: 100%;
            }
        }
    }

    .table-title {
        font-weight: bold;
        font-size: 18px;
    }

    .echarts {
        height: 300px;
        width: 100%;
    }

    .welcome-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .welcome-list > div {
        text-align: center;
        width: 14%;
    }

    .welcome-title {
        font-size: 20px;
        margin-bottom: 25px;
        color: #0A1C33;
    }

    .welcome-blue {
        color: #409EFF;
        font-size: 26px;
    }
</style>